export default "__VITE_ASSET__9mJpSsky__"